import cs from './const.js';
import AntString from './AntString.js';
import stringify from './stableStringify';

import moment from 'moment-timezone';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default {
    async getDeviceID() {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        return result.visitorId;
    },
    async registerPrepare(cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;
        var queryURL = AntString.clean(BaseURL + '/sys/Business/register/prepare');
        var header = { 'Content-Type': 'application/json', Accept: 'application/json' };
        try {
            var response = await fetch(queryURL, { method: 'POST', body: '{}', headers: header });
            var data = await response.json();
            if (cb) cb(data);
            return data;
        } catch (e) {
            if (cb) cb({ error: e });
            return { error: e };
        }
    },
    async isShortCodeExisted(code) {
        return new Promise(async (resolve) => {
            var URL = '/sys/Business/checkShortCode';

            var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
            if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

            var queryURL = AntString.clean(BaseURL + URL);

            const header = {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            };

            var that = this;
            fetch(queryURL, {
                method: 'POST',
                body: AntString.clean(
                    stringify({
                        short_code: code
                    })
                ),
                headers: header
            })
                .then((response) => response.json())
                .then((data) => {
                    var isExisted = data && !data.error && data.data && data.data.is_existed;
                    resolve(isExisted);
                })
                .catch((er) => {
                    resolve({ error: er });
                });
        });
    },

    registerRequest(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/register/request';
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;
        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        var that = this;
        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(obj)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    registerVerifyOTP(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/register/verifyOTP';
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        var that = this;
        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(obj)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    async registerSetAdminPassword(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/register/setAdminPassword';

        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        const deviceId = await this.getDeviceID();

        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(
                stringify({
                    ...obj,
                    device_id: deviceId,
                    timezone: obj.timezone || moment.tz.guess()
                })
            ),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    recoveryRequest(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/recovery/request';

        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(obj)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    recoveryVerifyOTP(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/recovery/verifyOTP';

        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(obj)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    async recoverySetAdminPassword(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // sessionStorage.clear();
        // localStorage.clear();
        // localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/sys/Business/recovery/setAdminPassword';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };
        const deviceId = await this.getDeviceID();

        obj.Sys_BaseLanguage = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(
                stringify({
                    ...obj,
                    device_id: deviceId,
                    timezone: obj.timezone || moment.tz.guess()
                })
            ),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    }
};
